export default __webpack_public_path__ + "static/media/vision-international.1da6287e.png";